export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["搜索"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您处于演示模式。余额和操作是练习用的。"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["转到工作台"])}
}